import React, { useContext } from 'react'
import { ProductsContext } from '../Global/ProductsContext'
import { CartContext } from '../Global/CartContext'
import image from '../images/internet.jpg'

export const Products = () => { 
   
   // product context
    const { products } = useContext(ProductsContext);
    
    // cart context
    const { dispatch } = useContext(CartContext);

    return (
        <>
            {products.length !== 0 && <h1 className="headcenter"> Designs </h1>}
            <div className='products-container'>
                {products.length === 0 && <div className="network">  
                   <div className="image-network">  
                       <img src={image} alt="net"/>
                       <p>  Your internet connection is slow... No products to display </p> 
                    </div>
                </div>} 
                {products.map(product => (
                    <div className='product-card' key={product.ProductID}> 
                        <div className='product-img'>
                            <img src={product.ProductImg} alt="not found" /> 
                        </div>
                        <div className='product-name'>
                            {product.ProductName}
                        </div>
                        <div className='product-price'>
                         GH₵ {product.ProductPrice}.00
                    </div>
                        <button className='addcart-btn' onClick={() => dispatch({ type: 'ADD_TO_CART', id: product.ProductID, product })}>BOOK NOW</button>
                    </div>
                ))}
            </div>
        </>
    )
}
